import React from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { BreadcrumbItemProps } from '../../../../shared/components/Breadcrumbs/BreadcrumbItem/BreadcrumbItem';
import Breadcrumbs from '../../../../shared/components/Breadcrumbs/Breadcrumbs';
import PageHeader from '../../../../shared/components/PageHeader/PageHeader';
import StyledButtonNE from '../../../../shared/components/StyledButtonNE/StyledButtonNE';
import Header from '../../../../shared/components/v3/Globals/Header/Header';
import { LOAD_BALANCE_ROUTE } from '../../../../shared/constants/auth';
import { CLICK_ACTION, LOAD_BALANCE } from '../../../../shared/constants/tagManager';
import tagManagerService from '../../../../shared/services/gtm/tagManagerService';
import { TRANSLATION_LOAD_BALANCE } from '../../../../shared/translations/rewards';
import { toLocaleNumberFormat } from '../../../../shared/utils/utils';

import './RewardsPageHeader.scss';

interface RewardsPageHeaderProps {
  breadcrumbs: BreadcrumbItemProps[];
  rewardsLoading: boolean;
  rewardsError: boolean;
  currency: string;
  balance: number;
  title: string;
  description: string;
  button?: boolean;
}

const RewardsPageHeader = ({
  breadcrumbs,
  rewardsLoading,
  rewardsError,
  currency,
  balance,
  title,
  description,
  button = true
}: RewardsPageHeaderProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const goToLoadBalance = () => {
    tagManagerService.pushEvent(CLICK_ACTION, LOAD_BALANCE);
    navigate(LOAD_BALANCE_ROUTE);
  };

  return (
    <div className="page-content-container">
      <Header />
      <Breadcrumbs items={breadcrumbs} />
      <PageHeader title={title} description={description}>
        {!rewardsLoading && !rewardsError && (
          <div className="rewards-header-card">
            <div>
              <p className="ne-font-body-sm m-0 whitespace-nowrap">{t(TRANSLATION_LOAD_BALANCE.header.card.title)}</p>
              <p className="ne-font-numeric-md m-0 whitespace-nowrap">
                {toLocaleNumberFormat(parseFloat(balance.toString()), { style: 'currency', currency: currency })}
              </p>
            </div>
            {button ? (
              <StyledButtonNE buttonType="secondary" action={goToLoadBalance} disabled={rewardsLoading || rewardsError}>
                {t(TRANSLATION_LOAD_BALANCE.header.card.button)}
              </StyledButtonNE>
            ) : (
              <div style={{ width: '113px' }}></div>
            )}
          </div>
        )}
      </PageHeader>
    </div>
  );
};

export default RewardsPageHeader;
